import { Suspense } from 'react';
import { useParams } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import { FullScreenLoading } from '~/components/common';
import useGetGameDetailQuery from '~/features/missionGame/useGetMissionGameDetailsQuery';
import GameDetailPage from './detail';
import GameMainPage from './main';

export default function GameEnteringRoutePage() {
  const { page, id: gameId } = useParams();

  if (!gameId) {
    return <div>Invalid game ID</div>;
  }

  return (
    <Suspense fallback={<FullScreenLoading />}>
      <Sentry.ErrorBoundary fallback={<div>Error</div>}>
        <GamePageContent gameId={gameId} page={page} />
      </Sentry.ErrorBoundary>
    </Suspense>
  );
}

function GamePageContent({ gameId, page }: { gameId: string; page?: string }) {
  const { data: gameDetails, isPending: isGetGameDetailQueryPending } =
    useGetGameDetailQuery({
      game_id: Number(gameId),
    });

  if (!isGetGameDetailQueryPending && !gameDetails)
    return <div>Error while fetching game details</div>;

  return (
    <div style={{ height: '100%' }}>
      {page === 'detail' ? (
        <GameDetailPage gameDetails={gameDetails} />
      ) : (
        <GameMainPage gameDetails={gameDetails} />
      )}
    </div>
  );
}
